// extracted by mini-css-extract-plugin
export const container = "ContentSection-module--container--3gToq";
export const dark = "ContentSection-module--dark--1Ewaa";
export const textContainer = "ContentSection-module--textContainer--2shAi";
export const backgroundIcon = "ContentSection-module--backgroundIcon--2eTDq";